export default __webpack_public_path__ + "static/media/young-handsome-physician-medical-robe-with-stethoscope.f36a5baf.jpg";